import { render } from "./WhoWeAre.vue?vue&type=template&id=0aac4597&ts=true"
import script from "./WhoWeAre.vue?vue&type=script&lang=ts"
export * from "./WhoWeAre.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__